package com.rainbowclubs.rainbow.data.requests

import com.rainbowclubs.rainbow.data.models.MembershipStatus
import com.rainbowclubs.rainbow.data.models.UserRole
import kotlinx.serialization.Serializable

@Serializable
data class UpdateMembershipStatusRequest(
    val status: MembershipStatus,
)

@Serializable
data class UpdateMembershipRequest(
    val status: MembershipStatus,
    val role: UserRole,
    val membershipData: Map<String, String>,
)
